import React from "react";
import PropTypes from 'prop-types';
import TitleBar from '../Layout/titleBar';
import { Row, Col } from 'react-flexbox-grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import './marcas.css';

class MarcaEdit extends React.Component {

    render() {
        const { marca, handleOnSave, handleOnCancel, handleOnChange, error } = this.props;
        return (
            <div className='crearEditarMarca'>

                {/* menú superior */}
                <TitleBar
                    title={((marca?.idMarca === 0) ? 'Nueva ' : 'Editar ') + this.props.entidad}
                    handleOnSave={handleOnSave}
                    handleOnBack={handleOnCancel}
                    showSearch={false}
                />

                <Paper className='myBox no-margin'>
                    <Row>
                        <Col md={12}>
                            <TextField 
                                className='myInput'
                                label='Nombre'
                                name='nombre'
                                fullWidth
                                required
                                value={marca.nombre}
                                onChange={handleOnChange}

                                error={error && error.nombre}
                                helperText={(error && error.nombre) ? error.nombre : ""}

                                style={{ margin: "10px", width: "98%", }}
                            />
                        </Col>
                    </Row>
                </Paper>
            </div>
        );
    }
}

MarcaEdit.propTypes = {
    marca: PropTypes.object.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    handleOnCancel: PropTypes.func.isRequired,
    handleOnChange: PropTypes.func.isRequired,
    error: PropTypes.object,
};

MarcaEdit.defaultProps = {
    marca: {},
};

export default MarcaEdit;


